import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
import { parse, format } from "date-fns";

// Extend twMerge to handle custom typography classes
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        // Custom typography classes that conflict with each other
        {
          text: [
            "9-reg",
            "11-med",
            "12-bold",
            "12-semi",
            "12-med",
            "12-med-tight",
            "12-reg",
            "14-semi",
            "14-semi-tight",
            "14-med",
            "14-med-tight",
            "14-reg",
            "16-bold",
            "16-semi",
            "16-med",
            "16-reg",
            "18-bold",
            "18-bold-tight",
            "18-semi",
            "18-semi-tight",
            "20-xbold",
            "20-xbold-tight",
            "20-bold",
            "20-semi",
            "24-bold-tight",
            "24-semi-tight",
            "26-bold",
            "26-xbold",
            "32-xbold",
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(input: string): string {
  try {
    if (input === "") return input; // Check if the string is empty
    // Parse the input string into a Date object
    const parsedDate = parse(input.split("")[0], "dd-MM-yyyy", new Date());

    // Format the Date object into the desired format
    const formattedDate = format(parsedDate, "dd MMMM yy");

    return formattedDate;
  } catch (error) {
    console.log(error);
    return input;
  }
}

export function formatFullDate(input: string): string {
  //input e.g. 2023-04-25T11:52:41.000000Z
  try {
    if (input === "") return input; // Check if the string is empty
    // Parse the input string into a Date object
    const formattedDate = format(new Date(input), "MMMM yyyy");
    return formattedDate;
  } catch (error) {
    console.log(error);
    return input;
  }
}
